/****************************************************
 * Module Name:  addShapeMappingModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import Utility from "../../utility/utility";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import ShapeMappingProxy from "../../utility/proxy/nivodautility/shapeMappingProxy";
import Select from "react-select";
import SaveIcon from '@mui/icons-material/Save';

export default class AddShapeMappingModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newshape: this.props.editOperation ? this.props.sourceData.shape : "",
            newdetailedshape: this.props.editOperation ? this.props.sourceData.detailedShape : "",
            shapeOptions: Constants.NIVODA_SHAPES,
            newshapeselect: this.props.editOperation ? Constants.NIVODA_SHAPES.filter(shape => shape.value === this.props.sourceData.shape) : "",

            showError: false,
            validateShapeMappingPresentSpinner: false,
            showValidationMessage: false,
            shapeMappingAvailable: true,

            shapeMappingValidationError: "",
            detailedShapeValidationError: "",
        };
    }

    handleSave = () => {
        let data = {
            id: this.props.editOperation ? this.props.sourceData.id : undefined,
            shape: this.state.newshape,
            detailedShape: this.state.newdetailedshape,
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data)) this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    validateShapeMappingPresent = (shapeMappingEntered) => {
        if (!shapeMappingEntered || shapeMappingEntered.trim() === "") return;

        this.setState({
            validateShapeMappingPresentSpinner: true,
        });

        ShapeMappingProxy.CheckShapeMappingAvailable(shapeMappingEntered, (response) => {
            //if we got response that means shape mapping is present at backend
            if (response) {
                //ShapeMappingName already present
                this.setState({
                    validateShapeMappingPresentSpinner: false,
                    showValidationMessage: true,
                    shapeMappingAvailable: false,
                });
            } else {
                //ShapeMappingName not available, so can be used
                this.setState({
                    validateShapeMappingPresentSpinner: false,
                    showValidationMessage: true,
                    shapeMappingAvailable: true,
                });
            }
        });
    };

    buttonDisable = () => {
        if (
            this.props.editOperation &&
            this.state.newshape === "" &&
            this.state.newdetailedshape === ""
        )
            return true;

        if (!this.props.editOperation)
            return (
                !this.state.showValidationMessage ||
                !this.state.shapeMappingAvailable ||
                this.state.newshape === "" ||
                this.state.newdetailedshape === ""
            );

        return false;
    };

    detailedShapeValidation = (e) => {

        this.setState({
            newdetailedshape: e.target.value.toUpperCase(),
            showValidationMessage: false,
            detailedShapeValidationError: Utility.CheckIsPresent(e.target.value)
                ? ""
                : "Enter valid detailed shape",
        });

        if (e.key === 'Enter' || e.type === 'blur') {
            if (Utility.CheckIsPresent(e.target.value)) {
                this.validateShapeMappingPresent(e.target.value);
            } else {
                this.setState({
                    detailedShapeValidationError: "Enter valid detailed shape",
                });
            }
        }
    }

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add shape Mapping validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit Shape Mapping" : "Add New Shape Mapping"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>
                                                <Form.Label>Shape Mapping Id</Form.Label>
                                            </td>
                                            <td>
                                                <Form.Label> - {this.props.sourceData.id}</Form.Label>
                                            </td>
                                        </tr>
                                    )}
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                    )}

                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Detailed Shape <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td width={"70%"}>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Detailed Shape (required)"
                                                placeholder="Enter Detailed Shape"
                                                value={this.state.newdetailedshape}
                                                onChange={(e) => this.detailedShapeValidation(e)}
                                                onBlur={(e) => { this.detailedShapeValidation(e) }}
                                                onKeyDown={(e) => { this.detailedShapeValidation(e) }}
                                                helperText={this.state.detailedShapeValidationError}
                                                error={this.state.detailedShapeValidationError.length > 0}
                                            />
                                            {this.state.validateShapeMappingPresentSpinner ? (
                                                <CircularProgress size="1rem" />
                                            ) : !this.state.showValidationMessage ? (
                                                <div />
                                            ) : this.state.shapeMappingAvailable !== undefined && (this.state.shapeMappingAvailable ? (
                                                <font style={{ fontSize: "14px", fontWeight: "500", color: "#4EC073" }}>Detailed Shape available</font>
                                            ) : (
                                                <font style={{ fontSize: "14px", fontWeight: "500", color: "red" }}>Detailed Shape not available</font>
                                            ))}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Shape <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td width={"70%"}>
                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    "& .MuiSelect-select": {
                                                        height: "0.5em !important"
                                                    }
                                                }}
                                            >
                                                <Select menuPlacement="auto"
                                                    blurInputOnSelect={false}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    value={this.state.newshapeselect}
                                                    isSearchable={true}
                                                    name="newshape"
                                                    menuPortalTarget={document.body}
                                                    styles={Constants.Styles}
                                                    options={this.state.shapeOptions}
                                                    onChange={(selectedOption) => this.setState({ newshape: selectedOption.value, newshapeselect: selectedOption })}
                                                />
                                            </Box>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}
